// extracted by mini-css-extract-plugin
module.exports = {"es-dialog":"SessionTimeout_es-dialog__Sz424"};